module.exports = __webpack_public_path__ + "static/img/1.9e35fcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technical/1.png
// module id = DSd6
// module chunks = 1